import { combineReducers } from 'redux'
import organizationRolesDetails from 'reducers/submittable/organizationRoleDetails'
import search from './search'
import paymentLookup from './paymentLookup'
import organizationDetails from './organizationDetails'
import userDetails from './userDetails'
import clone from './clone'
import mergeGMSUserAccounts from './mergeGMSUserAccounts'

const submittable = combineReducers({
  clone,
  mergeGMSUserAccounts,
  organizationDetails,
  organizationRolesDetails,
  paymentLookup,
  search,
  userDetails,
})

export default submittable
